import type { AnalyticsJS } from 'analytics.js';

import { getWindowAnalytics } from './snippet';

export function getSegmentClient(): AnalyticsJS {
    return getWindowAnalytics();
}
